const getDashboardDriveLists = state => state?.dashboard?.dashboardDriveList
const specialisationListData = state =>
  state?.dashboard?.getSpecialisationListForReport

const selectors = {
    getDashboardDriveLists,
    specialisationListData
}

export default selectors